import React, {useEffect, useRef, useState} from 'react';

import {useDispatch, useSelector} from "react-redux";
import {mailItem, setMoveId} from '../stores/mailbox'
import axiosInstance from "../libs/axiosInstant";

import PerfectScrollbar from 'perfect-scrollbar';
import Mail from "./Mail";
import {useMutation, useQueryClient} from "react-query";
import * as $ from "jquery";

import Reply from "./Reply";
import {useParams} from "react-router-dom";

const MailContent = () => {

    const {mailItemOpen, mailID} = useSelector((state) => state.mailBox)
    const dispatch = useDispatch()

    const { slug } = useParams()
    const closeContent = () => {
        dispatch(mailItem({id: 0, open: false}));

        $('body').removeClass('mailcontent-show');
    }

    const [msg, setMsg] = useState()
    const [replies, setReplies] = useState()
    const [isLoading, setIsLoading] = useState(false)
    const fetchMessage = async (msgID) => {
        setIsLoading(true)
        const { data } = await axiosInstance.get(`/inbox/message/${msgID}`)
        setMsg(data.row);
        setReplies(data.replies);
        setIsLoading(false)
        return data;
    }

    useEffect(() => {
        if(mailID > 0){
            fetchMessage(mailID)
            setOpenReply(false)
        }
    }, [mailID]);

    const mailContentRef = useRef(null); // Reference to the scroll container
    useEffect(() => {
        if(msg?.id) {
            const ps = new PerfectScrollbar(mailContentRef.current);
            return () => ps.destroy()
        }
    }, [msg]);


    /*----------- Actions -------------*/
    const moveRequest  = async ({msg_id, label}) => {
        const { data } = await axiosInstance.get(`/inbox/move/${label}/?id=${msg_id}`)
        return data;
    }

    const queryClient = useQueryClient();
    const mutation = useMutation(moveRequest, {
        onSuccess: (data) => {
            //console.log(data);
            queryClient.invalidateQueries(['labels']);
        },
        onError: (error) => {
            console.error('Error submitting data:', error);
        },
    });

    const moveHandle  = async (el, msg_id, label) => {
        dispatch(setMoveId(msg_id))
        el.currentTarget.classList.toggle('active');
        mutation.mutate({msg_id, label}); // Trigger the mutation with form data
        if(['trash'].includes(label)){
            closeContent()
        }
    }

    const [openReply, setOpenReply] = useState(false)
    const replyHandle  = () => {
        setOpenReply(true)

        const ref = mailContentRef.current;
        ref.scrollTop = ref.scrollHeight
    }

    if(isLoading){
        return (
            <div className={(mailItemOpen ? '' : 'd-none')}>
                <div id="mailContent" className="mailcontent ps ">
                    <div className="d-flex justify-content-center justify-align-center">
                        <div className="spinner-border" role="status">
                            <span className="visually-hidden">Loading...</span>
                        </div>
                        <strong role="status">Message Loading...</strong>
                    </div>
                </div>
            </div>
        )
    }

    if(msg?.id) {
        return (
            <div className={(mailItemOpen ? '' : 'd-none')}>
                <div id="mailContent" className="mailcontent" ref={mailContentRef}>
                    <div className="mailcontent-subject">
                        <nav className="nav">
                            <a id="mailBack" href="#" className="nav-link" onClick={closeContent}>
                                <i className="ri-arrow-left-line"/>
                            </a>
                            {!['sent'].includes(slug) &&
                                <>
                                    <a href="#" onClick={(el) => moveHandle(el, msg.id, 'archive')} className="nav-link"
                                       data-bs-toggle="tooltip" data-bs-placement="left"
                                       title="Archive" aria-label="Archive">
                                        <i className="ri-archive-drawer-line"/>
                                    </a>
                                    <a href="#" onClick={(el) => moveHandle(el, msg.id, 'spam')} className="nav-link"
                                       data-bs-toggle="tooltip" data-bs-placement="left"
                                       title="Spam" aria-label="Report Spam">
                                        <i className="ri-spam-2-line"/>
                                    </a>
                                    <a href="#" className="nav-link" data-bs-toggle="tooltip"
                                       data-bs-placement="left"
                                       title="Labels" aria-label="Labels">
                                        <i className="ri-price-tag-line"/>
                                    </a>
                                    <a onClick={(el) => moveHandle(el, msg.id, 'trash')} className="nav-link"
                                       data-bs-toggle="tooltip" data-bs-placement="left"
                                       title="Delete" aria-label="Delete">
                                        <i className="ri-delete-bin-5-line"/>
                                    </a>
                                </>
                            }
                            {/*<a href="#" className="nav-link" data-bs-toggle="tooltip" title="" data-bs-placement="left"
                               data-bs-original-title="More" aria-label="More">
                                <i className="ri-more-2-fill"/>
                            </a>*/}
                            <a href="#" onClick={closeContent} className="nav-link" data-bs-toggle="tooltip"
                               data-bs-placement="left" title="Close" aria-label="Close">
                                <i className="ri-close-fill"/>
                            </a>
                        </nav>
                        <h4>{msg.subject}</h4>
                    </div>

                    <div className="mailcontent-group">
                        {replies &&
                            replies?.map((reply_msg, i) => {
                                return <Mail key={i} msg={reply_msg} first={i === 0} setOpenReply={setOpenReply}/>
                            })
                        }
                        <Mail msg={msg} first={replies.length === 0} setOpenReply={setOpenReply}/>
                    </div>

                    {!['sent'].includes(slug) &&
                        <div className="mailcontent-footer">
                            <a href="#" className="btn btn-secondary btn-icontext" onClick={replyHandle}>
                                <i className="ri-reply-line me-1"/> Reply
                            </a>
                            {/*<a href="" className="btn btn-secondary btn-icontext">
                            <i className="ri-share-forward-line me-1"/> Forward
                        </a>*/}
                    </div>
                    }

                    {openReply &&
                        <div className="mailcontent-item">
                            <Reply msg={msg} setOpenReply={setOpenReply} fetchMessage={fetchMessage}/>
                        </div>
                    }


                </div>

                <div id="mailContent" className="mailcontent d-none">
                    <div className="mailcontent-placeholder">
                        <i className="ri-mail-send-line"></i>
                        <h5>No email has been selected</h5>
                    </div>
                </div>
            </div>
        );
    }
};

export default MailContent;